
import { useDispatch, useSelector } from 'react-redux';
import { selectModifiedFilter } from '@pages/filter/store/selectors';
import { setDistributionTypes, setOrderTypes, setCountries, setRegions, setDistributionRegions, setExecutionPlaces, setCustomerHierarchies, setMaterialTypes, setOnOffTrade, setDistricts, setDistributionDistricts } from '@pages/filter/store/slice';
import { useGetFullFilterQuery } from '@api/user/api';
import { CheckboxGroup } from 'components/checkbox/CheckboxGroup';
import { Checkbox } from 'components/checkbox/Checkbox';
import FilterDates from '@pages/filter/FilterDates';



interface FilterOptionsProps {
	disableModify: boolean,
}


export const FilterOptions = (props: FilterOptionsProps) => {
	const { disableModify } = props;

	const modifiedFilter = useSelector(selectModifiedFilter);

	const dispatch = useDispatch();
	const updateCountries = (value: string[]) => dispatch(setCountries(value));
	const updateDistributionTypes = (value: string[]) => dispatch(setDistributionTypes(value));
	const updateOrderTypes = (value: string[]) => dispatch(setOrderTypes(value));
	const updateMaterialTypes = (value: string[]) => dispatch(setMaterialTypes(value));
	const updateCustomerHierarchies = (value: string[]) => dispatch(setCustomerHierarchies(value));
	const updateExecutionPlaces = (value: string[]) => dispatch(setExecutionPlaces(value));
	const updateRegions = (value: string[]) => dispatch(setRegions(value));
	const updateDistributionRegions = (value: string[]) => dispatch(setDistributionRegions(value));
	const updateDistricts = (value: string[]) => dispatch(setDistricts(value));
	const updateDistributionDistricts = (value: string[]) => dispatch(setDistributionDistricts(value));
	const updateOnOffTrade = (value: string[]) => dispatch(setOnOffTrade(value));

	const { data } = useGetFullFilterQuery();

	
	if (!data) return (
		<div className='filter-options'>
		</div>
	);

	return (
		<div className='filter-options'>
				
			{data.countries && data.countries.length > 0 &&
				<CheckboxGroup
					isDisabled={disableModify}
					label='Země'
					value={modifiedFilter.countries}
					onChange={updateCountries}>
					{data.countries.map(x =>
						<Checkbox value={x.id} key={x.id}>{x.text}</Checkbox>
					)}		
				</CheckboxGroup>}

			{data.distributionTypes && data.distributionTypes.length > 0 &&
				<CheckboxGroup
					isDisabled={disableModify}
					label='Typ distribuce'
					value={modifiedFilter.distributionTypes}
					onChange={updateDistributionTypes}>
					{data.distributionTypes.map(x =>
						<Checkbox value={x.id} key={x.id}>{x.text}</Checkbox>
					)}		
				</CheckboxGroup>}

			{data.orderTypes && data.orderTypes.length > 0 &&
				<CheckboxGroup
					isDisabled={disableModify}
					label='Typ objednávky'
					value={modifiedFilter.orderTypes}
					onChange={updateOrderTypes}>
					{data.orderTypes.map(x =>
						<Checkbox value={x.id} key={x.id}>{x.text}</Checkbox>
					)}		
				</CheckboxGroup>}

			{data.onOffTrade && data.onOffTrade.length > 0 &&
				<CheckboxGroup
					isDisabled={disableModify}
					label='OnTrade / OffTrade'
					value={modifiedFilter.onOffTrade}
					onChange={updateOnOffTrade}>
					{data.onOffTrade.map(x =>
						<Checkbox value={x.id} key={x.id}>{x.text}</Checkbox>
					)}		
				</CheckboxGroup>}

			<FilterDates />

			{data.regions && data.regions.length > 0 &&
				<CheckboxGroup
					isDisabled={disableModify}
					label='Sales region'
					value={modifiedFilter.regions}
					onChange={updateRegions}>
					{data.regions.map(x =>
						<Checkbox value={x.id} key={x.id}>{x.text}</Checkbox>
					)}		
				</CheckboxGroup>}

			{data.districts && data.districts.length > 0 &&
				<CheckboxGroup
					isDisabled={disableModify}
					label='Sales distrikt'
					value={modifiedFilter.districts}
					onChange={updateDistricts}>
					{data.districts.map(x =>
						<Checkbox value={x.id} key={x.id}>{x.text}</Checkbox>
					)}		
				</CheckboxGroup>}

			{data.distributionRegions && data.distributionRegions.length > 0 &&
				<CheckboxGroup
					isDisabled={disableModify}
					label='Distribuční region'
					value={modifiedFilter.distributionRegions}
					onChange={updateDistributionRegions}>
					{data.distributionRegions.map(x =>
						<Checkbox value={x.id} key={x.id}>{x.text}</Checkbox>
					)}		
				</CheckboxGroup>}

			{data.executionPlaces && data.executionPlaces.length > 0 &&
				<CheckboxGroup
					isDisabled={disableModify}
					label='Lokalita'
					value={modifiedFilter.executionPlaces}
					onChange={updateExecutionPlaces}>
					{data.executionPlaces.map(x =>
						<Checkbox value={x.id} key={x.id}>{x.text}</Checkbox>
					)}		
				</CheckboxGroup>}

			{data.customerHierarchies && data.customerHierarchies.length > 0 &&
				<CheckboxGroup
					isDisabled={disableModify}
					label='Hiearchie zákazníků'
					value={modifiedFilter.customerHierarchies}
					onChange={updateCustomerHierarchies}>
					{data.customerHierarchies.map(x =>
						<Checkbox value={x.id} key={x.id}>{x.text}</Checkbox>
					)}		
				</CheckboxGroup>}

			{data.materialTypes && data.materialTypes.length > 0 &&
				<CheckboxGroup
					isDisabled={disableModify}
					label='Materiál'
					value={modifiedFilter.materialTypes}
					onChange={updateMaterialTypes}>
					{data.materialTypes.map(x =>
						<Checkbox value={x.id} key={x.id}>{x.text}</Checkbox>
					)}		
				</CheckboxGroup>}

			{data.distributionDistricts && data.distributionDistricts.length > 0 &&
				<CheckboxGroup
					isDisabled={disableModify}
					label='Distribuční distrikt'
					value={modifiedFilter.distributionDistricts}
					onChange={updateDistributionDistricts}>
					{data.distributionDistricts.map(x =>
						<Checkbox value={x.id} key={x.id}>{x.text}</Checkbox>
					)}		
				</CheckboxGroup>}
		</div>
	)
}

export default FilterOptions;